import { render } from "./ProyectoN2ServiciosIndividuales.vue?vue&type=template&id=5a031a2e&ts=true"
import script from "./ProyectoN2ServiciosIndividuales.vue?vue&type=script&lang=ts"
export * from "./ProyectoN2ServiciosIndividuales.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__